export default {
  isEnabledAuth(state) {
    return state.appFeatures && state.appFeatures.enabledAuth
  },
}
